import { createPlacement } from '@post-office/placement-common-v2';
import type { EligibleMessage } from '@post-office/shared-contracts/shared-request-middleware-context';
import { usePlacementApi } from '@post-office/use-placement-api';

import type { MessageTemplateContext } from './test-messages/test-message';

export const { createFrontend, createBackend } = createPlacement({
	placementId: 'jira-project-space-connected',
	options: {
		choreographer: {
			isDefaultEnabled: false,
		},
	},
});

export const PlacementFrontend = createFrontend<{
	onView: () => void;
}>((Messages) => ({ onView }) => {
	const { data, error, isLoading } = usePlacementApi<{
		messages: Array<EligibleMessage<MessageTemplateContext>>;
	}>('/');

	if (error) {
		throw error;
	}

	return (
		<>
			{!isLoading && data.messages.map((props) => <Messages.render {...props} onView={onView} />)}
		</>
	);
});

export const PlacementBackend = createBackend();
